import { createStore } from 'vuex'
import operate_stock from './stock'
import operate_stock_location from './stock_location'
import picking_list from './picking_list'

const store = createStore({
  actions: {
    clearAllStores({ dispatch }) {
      dispatch('operate_stock/clearAll', null, { root: true })
      dispatch('operate_stock_location/clearAll', null, { root: true })
      dispatch('picking_list/clearAll', null, { root: true })
    },
    clearDataStores({ dispatch }) {
      dispatch('operate_stock/clearAll', null, { root: true })
      dispatch('operate_stock_location/clearAll', null, { root: true })
      dispatch('picking_list/clearAll', null, { root: true })
    },
  },
  modules: {
    operate_stock,
    operate_stock_location,
    picking_list,
  },
})

export default store
